import { z } from 'zod';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { publicCurrencyRef } from './currency';
import { publicRuleRef } from './rule';

export const publicTransaction = extendApi(
  z.object({
    rule: extendApi(publicRuleRef.optional(), {
      description: 'Rule that triggered the transaction', // only displayed in OAS 3.1
    }),
    amount: extendApi(z.number().int(), {
      description: 'Amount of points earned (or burned if negative)',
      example: 10,
    }),
    currency: extendApi(publicCurrencyRef, {
      description: 'Currency affected by the change', // only displayed in OAS 3.1
    }),
  }),
  {
    tags: ['transaction-model', 'transaction', 'model'],
  } as RedocSchemaObject,
);

export const publicTransactionRef = extendApi(publicTransaction, {
  $ref: '#/components/schemas/Transaction',
} as RedocSchemaObject);

export type PublicTransaction = z.infer<typeof publicTransaction>;
